import styled from 'styled-components';

const FaqWrapper = styled.div`
  background-color: ${({ theme: { colors } }) => colors.gray.light};
  white-space: pre-wrap;
  padding-bottom: 100px;
`;

const FaqTitle = styled.div`
  margin-bottom: 60px;
`;

export { FaqWrapper, FaqTitle };
